import { render } from "./TopMenuBar.vue?vue&type=template&id=1db7d855"
import script from "./TopMenuBar.vue?vue&type=script&lang=js"
export * from "./TopMenuBar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__